"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _static = require("../static");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _pintuanOrderDetail = _interopRequireDefault(require("./pintuanOrderDetail.vue"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    OrderDetail: _pintuanOrderDetail.default
  },
  data: function data() {
    return {
      orderStateOption: _static.orderStateOption,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      customers: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.getCustomers();
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      dangaoActApi.getCakeOrderList(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    exportList: function exportList() {
      dangaoActApi.exportOrderList(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    },
    getCustomers: function getCustomers() {
      var _this2 = this;
      this.customers = [];
      orderListApi.activeCustomersApi().then(function (res) {
        _this2.customers = res;
      });
    }
  }
};